<script setup lang="ts">
import { defineProps, computed } from "vue";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  width: {
    type: String,
    required: false,
    default: "fit-content",
  },

  color: {
    type: String,
    required: false,
    default: "white",
  },

  shortcut: {
    type: String,
    required: false,
    default: "",
  },

  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },

  isVerticalButton : {
    type: Boolean,
    required: false,
    default: false,
  },

  isClassic : {
    type: Boolean,
    required: false,
    default: false,
  },

  isFlat : {
    type: Boolean,
    required: false,
    default: false,
  },

  isCancel : {
    type: Boolean,
    required: false,
    default : false
  },
  isDefault : {
    type: Boolean,
    required: false,
    default : false
  },
  focusable : {
    type: Boolean,
    required: false,
    default: true,
  }
});

const emit = defineEmits(["closeModal", "actionButton"]);

const addBgColor = () => {
  switch (props.color) {
    case "positive":
      return {
        color: "#fff",
        bg: "#14AE5C",
        hoverBg: "#17ca6a",
        hoverColor: "#ffffff",
      };
      break;
      case "yellow":
      return {
        color: "#000",
        bg: "#e8b931",
        hoverBg: "#eac045",
        hoverColor: "#000",
      };
      break;
      case "light-grey":
      return {
        color: "#000",
        bg: "#EBEEF5",
        hoverBg: "#edeff5",
        hoverColor: "#000",
      };
      break;
      case "pink":
      return {
        color: "#000",
        bg: "#EF78AB",
        hoverBg: "#f085b3",
        hoverColor: "#000",
      };
      break;
      case "purple":
      return {
        color: "#ffffff",
        bg: "#B97ED0",
        hoverBg: "#c08ad4",
        hoverColor: "#ffffff",
      };
      break;
      case "light-blue":
      return {
        color: "#ffffff",
        bg: "#6DD0DB",
        hoverBg: "#7bd4de",
        hoverColor: "#ffffff",
      };
      break;
      case "blue-gd":
      return {
        color: "#ffffff",
        bg: "#2B48A2",
        hoverBg: "#3152ba",
        hoverColor: "#ffffff",
      };
      break;
    case "blue":
      return {
        color: "#fff",
        bg: "#2B48A2",
        hoverBg: "#ced7f2",
        hoverColor: "#2b48a2",
      };
      break;
    case "white":
      return {
        color: "#ffffff",
        bg: "#2B48A2",
        hoverBg: "#3928CB",
        hoverColor: "#ffffff",
      };
      break;
    case "lightblue":
      return {
        color: "#ffffff",
        bg: "#74b9ff",
        hoverBg: "#0984e3",
        hoverColor: "#ffffff",
      };
      break;
      case "green":
      return {
        color: "#ffffff",
        bg: "#2ecc71",
        hoverBg: "#27ae60",
        hoverColor: "#ffffff",
      };
      break;
      case "lightblue":
      return {
        color: "#ffffff",
        bg: "#3498db",
        hoverBg: "#2980b9",
        hoverColor: "#ffffff",
      };
      break;
    case "grey":
      return {
        color: "#ffffff",
        bg: "#95a5a6",
        hoverBg: "#7f8c8d",
        hoverColor: "#ffffff",
      };
      break;
    
    case "whitelight":
      return {
        color: "#2c3e50",
        bg: "#ecf0f1",
        hoverBg: "#34495e",
        hoverColor: "#ffffff",
      };
      break;
    case "asphalt":
      return {
        color: "#ffffff",
        bg: "#2c3e50",
        hoverBg: "#34495e",
        hoverColor: "#ffffff",
      };
      break;
    case "red":
      return {
        color: "#ffffff",
        bg: "#ea0046",
        hoverBg: "#ffffff",
        hoverColor: "#ea0046",
      };
      break;
    case "warning":
      return {
        color: "#ffffff",
        bg: "#f1c40f",
        hoverBg: "#f39c12",
        hoverColor: "#ffffff",
      };
      break;
    case "danger":
      return {
        color: "#ffffff",
        bg: "#EC221F",
        hoverBg: "#EC221F",
        hoverColor: "#ffffff",
      };
      break;
    case "noir" : 
      return {
        color: "#ffffff",
        bg: "#333646",
        hoverBg: "#2b2d3b",
        hoverColor: "#ffffff",
      }
    case "cancel" :
    return {
        color: "#ea0046",
        bg: "#EC221F",
        hoverBg: "#ea0046",
        hoverColor: "#ffffff",
      };
    default:
      return {
        color: "white",
        bg: "#2B48A2",
        hoverBg: "#3928CB",
        hoverColor: "#ffffff",
      };
      break;
  }
};

const tabNumber = computed(() => (props.focusable ? undefined : "-1"));

</script>

<template>

    <!--<button class="button" :class="{'button--disabled' : props.disabled}" @click="props.action ? emit('actionButton') : emit('closeModal')"> -->
    <!-- <el-badge v-if="isCancel" class="container-btn" :value="'Echap'" type="secondary"> -->
        <button tabindex=-1  v-if="isCancel" class="button btn-cancel-echap-modal" :class="{ 'button--disabled': props.disabled, 'button-flat' : props.isFlat }" :disabled="props.disabled">
            <span class="button__title">
                {{ props.title }}
            </span>
        </button>
    <!--</el-badge> -->

    <!-- <el-badge v-else-if="isDefault" class="container-btn" :value="'Enter'" type="primary"> -->
        <button class="button btn-confirm-enter-modal" v-else-if="isDefault" :class="{ 'button--disabled': props.disabled, 'button-flat' : props.isFlat, 'btn--classic' : props.isClassic}" :disabled="props.disabled">
            <span class="button__title">
                {{ props.title }}
            </span>
        </button>
    <!--</el-badge> -->
    <button :tabindex="tabNumber" v-else class="button container-btn " :class="{ 'button--disabled': props.disabled, 'button-flat' : props.isFlat, 'vertical--button' : props.isVerticalButton, 'btn--classic' : props.isClassic}" :disabled="props.disabled">
            <span class="button__title">
                {{ props.title }}
            </span>
            <span class="shortcut-badge" v-if="props.shortcut != ''">{{ props.shortcut }}</span>
        </button>
</template>

<style lang="scss" scoped>
@use "../../assets/css/utils/_variables.scss" as *;

.container-btn {
    width: calc(v-bind("props.width"));
}

.vertical--button {
  vertical-align: top;
  padding-left: 5px;
  -webkit-writing-mode: vertical-rl;
}

.button {
  border: none;
  border-radius: 4px;
  padding: 0 0.75rem;
  height: 3rem;
  min-height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: v-bind("addBgColor().bg") !important;
  color: v-bind("addBgColor().color");
  width: 100%;
  cursor: pointer;

  &--disabled {
    filter: grayscale(1);
    opacity: 0.5;

    &.button:hover {
      background-color: v-bind("addBgColor().bg") !important;
      cursor: default;
      color: v-bind("addBgColor().color");
    }
  }

  &:focus {
    border: solid 2px v-bind("addBgColor().hoverBg") !important;
    outline: none;
  }

  &:hover {
    background-color: v-bind("addBgColor().hoverBg") !important;
    color: v-bind("addBgColor().hoverColor");
  }

  &__title {
    font-weight: $weight-m;
  }
  
}

.button-flat {
  height: 2rem !important;
  min-height: 2rem !important;
}

.btn-cancel-echap-modal {
    border: none;
    border-radius: 10px;
    padding: 0 0.75rem;
    height: 3rem;
    min-height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #EC221F;
    color: white !important;
    cursor: pointer;
    position: relative;
    flex-direction: column;
}

.btn-cancel-echap-modal::after {
    content: "(Echap)";
    font-size: 11px;
    color: white;
    margin-top: 5px;
}

.shortcut-badge {
  background:#6e88d9;
  color: white;
  border : 1px solid white;
  font-size: 14px;
  font-weight: bold;
  border-radius: 4px;
  padding: 4px 4px;
  margin-top: 5px;
  user-select: none;
}

.btn-confirm-enter-modal {
    border: none;
    border-radius: 10px;
    padding: 0 0.75rem;
    height: 3rem;
    min-height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #2B48A2;
    cursor: pointer;
    position: relative;
    flex-direction: column;
}

.btn-confirm-enter-modal::after {
    content: "(Entrée)";
    font-size: 11px;
    color: white;
    margin-top: 5px;
}

.btn--classic {
  border-radius: 10px;
  text-align: center;
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
}

</style>
